import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { IReportConfigEntry } from 'data-ng-custom-text';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-reports')
  .factory(
    'loadAllReportsCommand',
    (
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      getJwtTokenCommand: ICommand,
      appConfigModel: any,
      accountModel: any,
      loadApptSummariesCommand: ICommand,
      loadNotesCommand: ICommand,
      loadProgressReportsCommand: ICommand
    ): ICommand => {
      const promiseStub = () => $q.defer() as any;
      return defineCommandORM(
        'loadAllReportsCommand',
        (deferred: ng.IDeferred<IQuery[]>, activeReportTypes: IReportConfigEntry[]): void => {
          const studentNK = _4.get(accountModel, 'student_nk', '');
          const campusUrl = appConfigModel.getConfigProperty(`core-campus_url`);
          if (_4.isEmpty(campusUrl)) {
            deferred.resolve();
            return;
          }
          getJwtTokenCommand().then((token: any) => {
            const JWTToken = token.access_token;
            const apptSummariesConfig = _4.find(activeReportTypes, { nk: 'APPOINTMENT_SUMMARIES' });
            const notesConfig = _4.find(activeReportTypes, { nk: 'NOTES' });
            const progressReportsConfig = _4.find(activeReportTypes, { nk: 'PROGRESS_REPORTS' });
            $q.all({
              apptSummaries: !_4.isEmpty(apptSummariesConfig)
                ? loadApptSummariesCommand(apptSummariesConfig, studentNK, campusUrl, JWTToken)
                : promiseStub().resolve(),
              notes: !_4.isEmpty(notesConfig)
                ? loadNotesCommand(notesConfig, studentNK, campusUrl, JWTToken)
                : promiseStub().resolve(),
              progressReports: !_4.isEmpty(progressReportsConfig)
                ? loadProgressReportsCommand(progressReportsConfig, studentNK, campusUrl, JWTToken)
                : promiseStub().resolve()
            });
          });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/commands/load_all_reports_command.ts